export const analyzerTranslation = {
  StandardAnalyzerSearch: '표준 검색',
  KeywordAnalyzerSearch: '키워드 검색',
  SynonymAnalyzerSearch: '동의어 검색',
  KoreanAnalyzerSearch: '형태소 검색',
  JamoAnalyzerSearch: '자모 검색',
  JamoEdgeNgramAnalyzerSearch: '자모 Edge-Ngram 검색',
  KoreanJamoAnalyzerSearch: '형태소 + 자모 Edge-Ngram 검색',
  ChosungAnalyzerSearch: '초성 검색',
  EngtokorAnalyzerSearch: '영한 검색',
  KortoengAnalyzerSearch: '한영 검색',
  KoreanAnalyzerIndex: '형태소 인덱스',
  JamoEdgeNgramAnalyzerIndex: '자모 Edge-Ngram 인덱스',
  KoreanJamoEdgeNgramAnalyzerIndex: '형태소 + 자모 Edge-Ngram 인덱스',
  ChosungAnalyzerIndex: '초성 인덱스',
  ChosungEdgeNgramAnalyzerIndex: '초성 Edge-Ngram 인덱스',
  EngtokorAnalyzerIndex: '영한 인덱스',
  EngtokorEdgeNgramAnalyzerIndex: '영한 Edge-Ngram 인덱스',
  KortoengAnalyzerIndex: '한영 인덱스',
  KortoengEdgeNgramAnalyzerIndex: '한영 Edge-Ngram 인덱스',
};
